import appUtils from '../app_utils'
// import throttle from 'lodash/throttle'

// https://greensock.com/docs/v3/Installation
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const dataAttrSuffix = 'parallax'
const dataAttr = 'data-' + dataAttrSuffix

const getAttributeObject = function(str='') {
  // jquery .data() requires a data-name='{"name": "value"}' pattern, not good for minification
  const dataString = str.replace(/'/g, '"')
  let obj = {}
  try {
    obj = JSON.parse(dataString)
  } catch (e) {
    console.log(e)
  } finally {
    return obj
  }
}

class ParallaxHeader {
  constructor(target, args = {index: 0}) {
    this.target = target
    this.$el = $(this.target)
    this.tl = null
    this.alphaTl = null
    this.$items = []

    this.id = dataAttrSuffix + '-' + args.index
    if(this.$el.attr('id')) {
      this.id = this.$el.attr('id')
    } else {
      this.$el.attr('id', this.id)
    }

    this.$bg = this.$el.find('[' + dataAttr + '-bg]')

    this.$items = this.$el.find('[' + dataAttr + '-layer]')

    this.$itemsWrapper = this.$el.find('[' + dataAttr + '-layers]').first()

    this.itemsWrapperHeight = 0 //itemsWrapperHeight cache

    this.init()
  }

  setTimeline() {
    const params_default = {
      trigger: this.target,
      start: 0, // "top " + appUtils.headerHeight(), "top top" 50 "top bottom"
      // "bottom center" means "when the bottom of the endTrigger hits the center of the scroller".
      end:  "bottom center", //"bottom top", // "+=500"
      scrub: true, //0.1, would take 0.1 second to catch up
      onToggle: self => {
        /*
        if (!this.bgFull) {
          this.bgFull = true
          gsap.to(this.$bg, {opacity: 1, scale: 1})
        }
        */
      },
      toggleClass: 'active'
    }
    let params = {}
    if(this.$el.attr(dataAttr)) {
      params = Object.assign({}, params_default, getAttributeObject(this.$el.attr(dataAttr)))
    } else {
      params = Object.assign({}, params_default)
    }

    this.tl = gsap.timeline({
      scrollTrigger: params
    })

    
    // initial state not required using gsap.from
    // https://greensock.com/forums/topic/21159-animating-variable-fonts/
    gsap.set(this.$bg, {opacity: 0, scale: 1.2})
    const tl = gsap.timeline({ defaults: { ease: 'power' }})
    .to(this.$bg, {opacity: 1, duration: 0.3})
    .to(this.$bg, {scale: 1, duration: 2}, '<-0.3')
    .fromTo(this.$el.find('[data-title]'), {opacity: 0, y: 20}, { opacity: 1, y: 0, duration: 0.6 })
    .fromTo(this.$el.find('[data-text]'), {opacity: 0, y: -20}, { opacity: 1, y: 0, duration: 0.6 }, '<')
    .call(()=>{
      // appUtils.scrollUnlock()
      this.$el.addClass('intro-end')
    })

    this.alphaTl = gsap.timeline({
      scrollTrigger: {
        trigger: this.target,
        start: 0,
        end: "bottom top",
        scrub: true
      }
    })
    this.alphaTl.to(this.$el, {opacity: 0})
  }

  onResize() {
    const itemsWrapperHeight = this.$itemsWrapper.height()
    let paddingBottom = false

    // prevent reinit on mobile, when address bar disapperars
    if (Math.abs(itemsWrapperHeight - this.itemsWrapperHeight) < 100) {
      return false
    }

    this.itemsWrapperHeight = itemsWrapperHeight

    // reste timeline and  positions
    // https://greensock.com/docs/v3/GSAP/Timeline/clear()
    this.tl.clear()
    this.$items.each((index, layer) => {
      gsap.set(layer, {
        y: 0,
        scaleX: 1,
        scaleY: 1
      })
    })
    //gsap.utils.toArray("#" + this.id + " [d' + dataAttr + '-item]")
    //this.$items.forEach(layer => {

    this.$items.each((index, layer) => {
      const depth = layer.dataset.depth
      const scale = layer.dataset.scale
      let props = {ease: 'none'}
      if (scale) {
        props.scaleX = scale
        props.scaleY = scale
        props.transformOrigin = 'top center'
        paddingBottom = true
      } else if (depth) {
        //props.y = (depth * 100) + '%' // (layer.offsetHeight * depth)
        props.y = (itemsWrapperHeight * depth) // percent of wrapper height, to support small absolute postioned layers
      }
      if (scale || depth) {
        this.tl.to(layer, props, 0)
      }
    })

    if (paddingBottom) {
      this.$itemsWrapper.addClass('p-b')
    } else {
      this.$itemsWrapper.removeClass('p-b')
    }
  }

  init() {
    this.setTimeline()
    this.onResize()
    this.$el.addClass('ready')

    const onResize = this.onResize.bind(this)
    this.handleResize = onResize
    // https://greensock.com/docs/v3/Plugins/ScrollTrigger/static.refresh()
    ScrollTrigger.addEventListener('refreshInit', this.handleResize) // update timeline before refresh
  }
  destroy() {
    /*
    Kills the ScrollTrigger instance, immediately unpinning and restoring any pin-related changes made to the DOM by ScrollTrigger and removing all scroll-related listeners, etc. so that the instance is eligible for garbage collection.
    */
    if (this.tl) {
      this.tl.scrollTrigger.kill()
      this.tl.kill()
    }
    if (this.alphaTl) {
      this.alphaTl.scrollTrigger.kill()
      this.alphaTl.kill()
    }

    ScrollTrigger.removeEventListener('refreshInit', this.handleResize)
  }
}

export default {dataAttr: dataAttr, sectionClass: ParallaxHeader}
